module.exports = __webpack_public_path__ + "img/HC2018-165.f2b99738.jpg";